import { render, staticRenderFns } from "./refresh_web_design.vue?vue&type=template&id=f666c816&lang=pug&"
import script from "./refresh_web_design.vue?vue&type=script&lang=js&"
export * from "./refresh_web_design.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports